import React from 'react';

// Template for displaying error messages. Use this component
// wherever an error may occur that needs to be displayed to the user.

const ErrorMessage = props => {
    return (
    <div
        className = "alert alert-danger"
        role = "alert"
        style = {{ marginTop: "5px"}}
    >
        {props.errorMessage}
    </div>
    );
}

export default ErrorMessage;